import { useTheme } from "@mui/material/styles";
import { getPanelLegacyColorsShim } from "./panelLegacyColorsShim";

/** Panel route'larında legacy `tokens(theme.palette.mode)` yerine kullanın. */
export default function usePanelLegacyColors() {
  const theme = useTheme();
  return getPanelLegacyColorsShim(theme.palette.mode);
}
